import React from "react";
import { ViewMode, Theme } from "../types/types";

interface ViewToggleProps {
  viewMode: ViewMode;
  onToggle: (mode: ViewMode) => void;
  theme: Theme;
}

const btnStyle = (active: boolean, theme: Theme) => ({
  backgroundColor: active ? theme.accent : theme.surface,
  color: active ? "#fff" : theme.textSecondary,
  border: `1px solid ${theme.border}`,
  padding: "6px 12px",
  cursor: "pointer",
  fontSize: "14px",
});

export const ViewToggle: React.FC<ViewToggleProps> = ({ viewMode, onToggle, theme }) => {
  return (
    <div style={{ display: "flex", borderRadius: "6px", overflow: "hidden" }}>
      <button
        style={{ ...btnStyle(viewMode === "grid", theme), borderRadius: "6px 0 0 6px" }}
        onClick={() => onToggle("grid")}
        title="Grid view"
      >
        ▦
      </button>
      <button
        style={{ ...btnStyle(viewMode === "list", theme), borderRadius: "0 6px 6px 0" }}
        onClick={() => onToggle("list")}
        title="List view"
      >
        ☰
      </button>
    </div>
  );
};
